export default {
    navigation: {
        info: "About",
        open_calls: "Open Calls",
        spaces: "Spaces Booking",
        classes: "Practices",
        blog: "Bookmarks",
        artists: "Community",
        login: "Login",
        account: "Account",
    },
    calendar: {
        artistic: "Artistic Residencies",
        technical: "Technical Residencies",
        reclamar_tempo: "Reclamar Tempo",
        residences: "Residências Cruzadas",
        reservation: "Spaces Booking",
        lesson: "Practices",
        public: "Others",
    },
    footer: {
        informations: "Informations",
        subscribe_newsletter: "Subscribe newsletter",
        privacy_policy: "Privacy Policy",
        cookies_policy: "Cookies Policy",
        terms_use: "Terms and conditions",
        links: "Links",
        facebook: "Facebook",
        instagram: "Instagram",
        newsletter: "Newsletter",
        emails: "Email",
        address: "Address",
        phone: "Phone",
    },
    login: {
        register: "Register",
        login: "Login",
        intro: "Hello! Enter your login details.",
        email: "Email",
        email_placeholder: "Email",
        password: "Password",
        password_placeholder: "Password",
        recover: "Recover Password",
        signIn: "Sign In",
        confirm_password_placeholder: "Confirm Password",
        error: "User not found",
    },
    classes: {
        with: "w/",
        online: "[Online Class]",
        local: "Space",
        price: "Price",
        level: "Level",
        level_1: "Beginner",
        level_2: "Intermediate",
        level_3: "Advanced",
        free: "Free",
        buy: "Buy",
        see_more: "See more",
        see_less: "See less",
        see_details: "See Details",
        close_details: "Close Details",
        reserve: "Reserve",
        conditions: "Admission conditions",
        practice: "practice",
        practices: "practices",
    },
    recover: {
        register: "Register",
        login: "Login",
        back: "Back to login",
        intro: "When entering your email, you will receive an email with the steps to recover your password.",
        submit: "Recover password",
        success: "Email sent with success",
        error: "An error occurred while recovering your password. Please, try again later.",
    },
    newsletter: {
        button: "Subscribe Newsletter",
        text: "Join our mailing list and get the news from CAMPUS Paulo Cunha e Silva.",
        placeholder: "Insert your email",
        success: "Thanks for subscribing to our newsletter. Please confirm this subscription in your email address.",
    },
    cookies: {
        button: "Accept",
        text: "This website uses cookies to improve your experience. If you click on Accept you're agreeing with our",
        text_privacy: "Cookies Policy",
    },
    validation: {
        completed: "completed",
        required: "The field is required",
        email: "Email is not valid",
        optional: " (optional)",
        date: "Date is not valid",
        max_chars: (value) =>
            "Must not have more than " + value + " characters",
        min: (value) => "Must select at least " + value,
        max: (value) => "Must not select more than " + value,
        equal: (value) => "Must select " + value,
        min_slots: "Must select at least 4 hours",
        min_string: (min) =>
            "The field must be at least " + min + " characters",
        confirm: "Password do not match",
        email_exists:
            "This email is already being used. If it's yours, please login.",
        register_error:
            "An error occurred while creating your account. Please, try again later.",
        booking_slots: "Bookings must always have at least 4 consecutive slots",
    },
    account: {
        my_account: "My account",
        logout: "Logout",
        profile: "Profile",
        artistic: "Artistic residencies",
        technical: "Technical residencies",
        reclamar_tempo: "Reclamar Tempo",
        reservation: "Spaces Booking",
        history: "Booking History",
        application_history: "Application History",
        edit: "Edit",
        blocked: "You do not currently have access to the spaces booking platform. For further information, please contact us by ",

        delete_account: "Delete Account",
        delete_account_text: "Do you really want to delete your account?",

        name: "Name",
        email: "Email",
        type: "Structure",
        password: "Password",
        gender: "Gender",
        birthday: "Date of birth",
        nationality: "Nationality",
        address: "Address",
        postal_code: "Postal Code",
        city: "City",
        district: "District",
        country: "Country",
        vat: "VAT number",
        phone: "Mobile number",
        website: "Website",
        biography: "Biography",
        photo: "Photo",

        edit_title: "Edit Profile",

        available_quota: "hours available",
        quota_empty: (days) =>
            "Your hours bank is empty. This hours bank will be renewed after " +
            days +
            " days!",

        button_application: "Application form",
        button_rules: "Rules",
        button_soon: "Coming soon",
        button_mentors: "Critical regard",
        button_jury: "Jury",
        button_external: "Outside eyes",
        button_booking: "Book",
        button_terms: "Terms and conditions",
        button_faqs: "FAQs",
        button_add_pdf: "Add PDF",
        button_remove_pdf: "Remove PDF",
        button_save: "Save",

        faq_1: "Residencies",
        faq_2: "Reclamar Tempo",
        faq_3: "Spaces Booking",

        artistics_type: "Artistic residencies APPLICATION",
        technics_type: "Technical residencies APPLICATION",
        claim_type: "RECLAMAR TEMPO APPLICATION",
        space_type: "SPACES BOOKING",
    },
    artistic_booking: {
        title: "Artistic residencies APPLICATION",
        submit: "Submit",
        success: "Your application has been successfully submitted.",
        success_button: "OK thanks!",
        error: "An error occurred. Please, try again later.",
        max_chars: (value) => "[max. " + value + " characters incl. spaces]",

        confirm_title: "Confirm Application",
        confirm_text: "Do you really want to confirm this application?",

        cancel_title: "Cancel Application",
        cancel_text: "Do you really want to cancel this application?",

        step_1_email_title: "Insert the following data",
        step_1_email_placeholder: "Email",
        step_1_phone_placeholder: "Phone Number",
        step_1_name_placeholder: "Candidate artist/collective/entity name",
        step_1_type_placeholder:
            "Structure type (collective, individual artist, etc)",
        step_1_terms_title:
            "I have read and understood the open call terms and conditions.",

        step_2_birthday_title: "Date of birth (if applicable)",
        step_2_birthday_placeholder: "DD-MM-AAAA",
        step_2_gender_title: "Gender",
        step_2_gender_op_1: "Male",
        step_2_gender_op_2: "Female",
        step_2_gender_op_3: "Non binary / Other",
        step_2_gender_op_4: "Prefer not to say",

        step_3_address_title: "Enter your fiscal data",
        step_3_address_placeholder: "Address",
        step_3_postal_placeholder: "Postal Code",
        step_3_city_placeholder: "City",
        step_3_district_placeholder: "District",
        step_3_country_placeholder: "Country",
        step_3_nif_placeholder: "VAT number",
        step_3_nationality_placeholder: "Nationality",
        step_3_photo_placeholder: "ID Photo",
        step_3_tax_proof_placeholder: "Proof tax residence",
        step_3_tax_proof_help:
            "Candidates must provide proof of their residence, under penalty of exclusion, by sending proof of tax residence, i.e., a certificate issued by the Tax and Customs Authority Portal (or equivalent document in the case of foreign applications). In the case of legal entities, a copy of the Legal Entity Card (or equivalent document in the case of foreign applications) must be presented.",

        step_4_website_title: "Professional links",
        step_4_website_placeholder: "Website (optional)",
        step_4_facebook_placeholder: "Facebook (optional)",
        step_4_instagram_placeholder: "Instagram (optional)",
        step_4_vimeo_placeholder: "Vimeo (optional)",
        step_4_youtube_placeholder: "Youtube (optional)",

        step_5_title_title: "Tell us about your research project",
        step_5_title_placeholder: "Project name",
        step_5_pitch_placeholder: "Project pitch link (optional)",
        step_5_pitch_help:
            "Make sure the video does not require login or download. If a password is required, tell us which one in the field above (in front of the video link).",
        step_5_cover_placeholder: "Project photo",
        step_5_area_title: "Artistic area",
        step_5_area_op_1: "Dance",
        step_5_area_op_2: "Theatre",
        step_5_area_op_3: "Contemporary circus",
        step_5_area_op_4: "Disciplinary crossings",
        step_5_area_op_5: "Animated forms",

        step_6_bio_title:
            "Biography of the artist / Collective requesting the booking.",
        step_6_bio_placeholder:
            "Please indicate your professional experience as well as training obtained in the area.",
        step_6_bio_max: "[max. 10000 characters incl. spaces]",
        step_6_work_type_placeholder:
            "Type of work (research, creation, rehearsals, reassembly) and motivation",
        step_6_work_type_max: "[max. 2000 characters incl. spaces]",
        step_6_synopsis_placeholder: "Synopsis of the project to be developed",
        step_6_synopsis_max: "[max. 2000 characters incl. spaces]",
        step_6_description_placeholder:
            "Project description (contextualization and relevance in the artistic path)",
        step_6_description_max: "[max. 8000 characters incl. spaces]",
        step_6_schedule_placeholder: "Project schedule",
        step_6_schedule_max: "[max. 2000 characters incl. spaces]",

        step_7_bio_placeholder: "Artistic team biographies",
        step_7_bio_max: "[max. 8000 characters incl. spaces]",
        step_7_financing_title: "Does the work have other sources of funding?",
        step_7_financing_op_1: "Yes",
        step_7_financing_op_2: "No",
        step_7_financing_op_3: "Which are?",
        step_7_video_links_title:
            "Video links from previous works / rehearsals (Please describe why you chose to include each video. Make sure all videos are accessible, that doesn’t require downloads or logins. If a password is required, include the correct password)",
        step_7_video_links_placeholder: "Links (optional)",

        step_8_team_title:
            "Name and role of team members that will be part of the residency",
        step_8_team_placeholder: "Name / role",
        step_8_hosting_title: "Accommodation need",
        step_8_hosting_subtitle:
            "The accommodation will be confirmed later subject to availability of capacity (max. 1 room per project, 2 people per room)",
        step_8_hosting_placeholder: "For which team members?",
        step_8_reduced_title: "Team members with reduced mobility",
        step_8_reduced_placeholder: "Enter the name of the elements (optional)",

        step_9_possible_dates_title: "Possible periods for residencies",
        step_9_possible_dates_placeholder:
            "Please indicate the options for your residency, choosing a maximum of five dates, within the indicated periods.",
        step_9_dramaturgists_title:
            "Outside eyes/playwrights (optional, max. 3 names)",
        step_9_eco_production_title:
            "I want to apply for the Eco-Production programme",
        step_9_eco_production_subtitle:
            "This support is applicable if the artistic team is based in the city of Porto and has at least 1 member responsible for production and/or management",

        step_10_open_placeholder:
            "Format proposal to the opening moment of process (talk, artist talk, open doors)",
        step_10_open_max: "[max. 2000 characters incl. spaces]",
        step_10_others_placeholder: "Others",
        step_10_others_max: "[max. 2000 characters incl. spaces]",
    },
    reclamar_tempo_booking: {
        title: "Reclamar tempo candidatura",
    },
    claim_booking: {
        title: "Reclamar tempo candidatura",
        submit: "Submit",
        success: "Your application has been successfully submitted.",
        success_button: "OK thanks!",
        error: "An error occurred. Please, try again later.",

        step_4_synopsis_placeholder: "Synopsis of the project to be developed",
        step_4_synopsis_max: "[max. 2000 characters incl. spaces]",
        step_4_description_placeholder:
            "Description of the research to be developed, with the theme on which investigation is concerned",
        step_4_description_max: "[max. 5000 characters incl. spaces]",
        step_4_development_placeholder:
            "How research is important for development of your path and your artistic practice?",
        step_4_development_max: "[max. 5000 characters incl. spaces]",
        step_4_concept_placeholder:
            "Tell us about the importance of the research concept in your artistic pratice",
        step_4_concept_max: "[max. 5000 characters incl. spaces]",

        step_5_bio_placeholder: "Artistic team biographies",
        step_5_bio_max: "[max. 8000 characters incl. spaces]",
        step_5_riders_placeholder:
            "Rider with contact of the artist/collective technical director and work plan proposal",
        step_5_financing_title: "The proposal has other sources of funding?",
        step_5_video_links_title:
            "Video links from previous works / rehearsals (Please describe why you chose to include each video. Make sure all videos are accessible, that doesn’t require downloads or logins. If a password is required, include the correct password)",
        step_5_video_links_placeholder: "Links",

        step_6_others_placeholder: "Others",
        step_6_others_max: "[max. 2000 characters incl. spaces]",
    },
    technical_booking: {
        title: "Residencias Tecnicas candidatura",
        submit: "Submit",
        success: "Your application has been successfully submitted.",
        success_button: "OK thanks!",
        error: "An error occurred. Please, try again later.",

        step_6_schedule_placeholder:
            "Work plan proposal. To be confirmed later by the technical team of Teatro Municipal do Porto if the project is selected",

        step_7_riders_placeholder:
            "Technical rider with contact from the artist/company's technical director",

        step_8_hosting_subtitle:
            "The accommodation will be confirmed later subject to availability of capacity (max. 4 people per apartment)",

        step_9_date_title: "Residence period you prefer (choose only 1 option)",
        step_9_others_placeholder: "Others",
        step_9_others_max: "[max. 2000 characters incl. spaces]",
    },
    spaces_booking: {
        title: "Spaces Booking",
        submit: "Submit",
        success:
            "Your booking is pending, awaiting validation by the CAMPUS team. You will receive an email with confirmation and validation of your booking.",
        success_button: "OK thanks!",
        error: "An error occurred. Please, try again later.",

        floor0: "GroundFloor",
        floor1: "FirstFloor",
        workshop: "Workshop",

        cancel_title: "Cancel Booking",
        cancel_text: "Do you really want to cancel this booking?",
        cancel_confirm: "Yes",
        cancel_reject: "No",

        confirm_title: "Confirm Booking",
        confirm_text: "Do you really want to confirm this booking?",

        step_admin_title:
            "Insert an user ID and which type of reservation you want to make.",
        step_admin_user_id_placeholder: "User ID",
        step_admin_type_placeholder: "Type",

        step_1_studio_title: "Which studio do you want to book?",
        step_1_studio_type_1: "Floor 0",
        step_1_studio_type_2: "Floor 1",
        step_1_studio_type_3: "Other",
        step_1_studio_1: "Studio 1",
        step_1_studio_2: "Studio 2",
        step_1_studio_3: "Studio 3",
        step_1_studio_4: "Studio 4",
        step_1_studio_5: "Other Spaces",

        step_2_description_title: "For what purpose do you want to book?",
        step_2_description_placeholder:
            "Please identify the reasons for booking space, mentioning the title of the project/research for which it is intended and a brief description and timing of it.",

        step_2_others_description_title:
            "What space do you want to book (living room, workstation, garden, yard, etc)?",
        step_2_others_description_placeholder:
            "Please indicate which space you want, date and period of use.",

        step_4_team_title:
            "Indicate the name and function of the entire team presente in the use of this space. Only the names indicated will have access to CAMPUS PCS.",
        step_4_team_placeholder: "",

        step_5_financing_title: "Does the project have financial support?",

        step_6_requests_title: "Do you have any special requests?",
        step_6_requests_placeholder:
            "Please indicate the technical material you need, use of scenography and props, shoes, etc.",
        step_6_terms_title:
            "I agree with the CAMPUS Spaces Booking Terms and Conditions.",
    },
    spaces: {
        title: "Studios",
        info_title: "Spaces",
        conditions_text:
            "Aside from these spaces, there are:\n– 2 rooms (suites), one on each floor, each for 2 people, with a private bathroom, able to accommodate 4 people in total;\n– Shared toilets and shower rooms on each floor. A bathroom and a room for persons with reduced mobility on the ground floor;\n– Lockers and a storeroom to put away props and small sceneries;\n– Several outdoor spaces that can also be used.",
        visual_stories: "Accessible Route",
    },
    open_calls: {
        button_application_open: "Application form",
        button_results: "Selected Projects",
        button_rules: "Rules",
        button_soon: "Coming Soon",
        artistics_subtitle:
            "Apoio ao desenvolvimento de projetos experimentais e inovadores no campo das Artes Visuais.",
        claim_subtitle:
            "Apoio ao desenvolvimento de projetos experimentais e inovadores no campo das Artes Visuais.",
        technics_subtitle:
            "Apoio ao desenvolvimento de projetos experimentais e inovadores no campo das Artes Visuais.",
    },
    library: {
        title: "Library",
        year: "1980/2021",
        description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonum- my nibh euismod tincidunt utlaoreet dolore maeum iriure dolor in hendrerit invulputate velit esse molestie consequat, vel illumdolopraesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.",
        see_more: "See more",
    },
    info: {
        bio_name: "Paulo Cunha e Silva",
        bio_title: "Open call",
        bio_subtitle:
            "Paulo Cunha e Silva é um programa de residências artísticas para as artes na cidade do Porto.",
        mission_subtitle:
            "O CAMPUS é um novo centro de residências artísticas para as artes performativas na cidade do Porto.",
        team_title: "TEAM",
        project_title: "Artistic Project",
        project_description: "Outras utilizações do espaço",
        classes: "Practices",
        space: "Spaces Booking",
        claim: "Reclamar Tempo",
        technic: "Technical Residencies",
        artistic: "Artistic Residencies",
    },
    home: {
        blog: "Bookmarks",
        blog_filter_all: "All",
        blog_back: "Go to Bookmarks",
        blog_share: "Share",
        see_more: "See more",
        search: "Search",
        calendar: "Calendar",
        search_articles: "Articles",
        search_artists: "Artists",
        search_lessons: "Practices",
        search_open_calls: "Open Calls",
        search_empty:
            "We couldn't find what you're looking for. Try searching using other words.",
        calendar: "Calendar",
        calendar_schedule: "PROGRAMMES\n2023-2024",
        calendar_subtitle:
            "The several spaces of CAMPUS Paulo Cunha e Silva are used by artists from the performing arts field. On this Calendar, you can see the daily occupation.",
    },
    artist: {
        title: "Artist",
        contents: "Contents",
        social: "Social Networks",
        season: "Season",
        project: "Project",
        type: "Type",
        types: {
            artist: "Artist",
            judge: "Jury",
            critic: "Critical Regard",
            outside_eyes: "Outside Eyes",
        },
    },
    reset: {
        title: "Enter your new password",
        submit: "Reset",
        error: "Email is not correct or token has expired. Please, try resetting password again.",
        success:
            "Your password has been reset! You can now login with your new password.",
    },
    register: {
        register: "Register",
        login: "Login",
        submit: "Submit",
        success_button: "OK thanks!",
        success:
            "Your registration is pending, awaiting validation by the CAMPUS team. You will receive an email with confirmation and validation of your registration.",
        step_1_name_title:
            "Hello! What is the name of the artist, collective or entity you want to register?",
        step_1_name_placeholder: "Write your answer here...",

        step_2_type_title:
            "Indicate the type of structure (collective, individual artist, etc)?",
        step_2_type_placeholder: "Write your answer here...",

        step_3_gender_title: "Gender",
        step_3_gender_op_1: "Male",
        step_3_gender_op_2: "Female",
        step_3_gender_op_3: "Non binary / Other",
        step_3_gender_op_4: "Prefer not to say",

        step_4_date_title:
            "What is your date of birth or date of creation of the collective/entity.",
        step_4_date_placeholder: "DD-MM-AAAA",

        step_5_nationality_title: "Indicate your nationality",
        step_5_nationality_placeholder: "Write your answer here...",

        step_6_address_title: "Enter your fiscal data",
        step_6_address_placeholder: "Address",
        step_6_postal_placeholder: "Postal Code",
        step_6_city_placeholder: "City",
        step_6_district_placeholder: "District",
        step_6_country_placeholder: "Country",

        step_7_nif_title: "Enter your VAT number",
        step_7_nif_placeholder: "Write your answer here...",

        step_8_phone_title: "Enter your mobile number",
        step_8_phone_placeholder: "Write your answer here...",

        step_9_website_title: "Tell us about yourself",
        step_9_website_placeholder: "Website or digital platform...",
        step_9_bio_placeholder:
            "Biography (please indicate your professional experience as well as training obtained in the area)",
        step_9_bio_max: "[max. 1000 characters incl. spaces]",
        step_9_photo_placeholder: "Photo",
        step_9_photo_size: "Photo must be smaller than 5Mb",
        step_9_file_size: "File must be smaller than 5Mb",
        step_9_photo_resolution: "Width and Height must not exceed 2500x2500",

        step_10_email_title: "Enter your email and password",
        step_10_email_placeholder: "Email",
        step_10_password_placeholder: "Password",
        step_10_password_confirm_placeholder: "Confirm Password",

        step_10_terms_title:
            "I agree with the CAMPUS Spaces Booking Terms and Conditions.",
        step_10_newsletter_title:
            "I want to receive information from CAMPUS through the Newsletter",
    },
};
